import request from '../request'

//获取自己的志愿列表
export function getUserVooluteer(params) {
  return request({ url: '/api/Volunteer/getUserVooluteer',method: 'post',data: params})
}
//获取智能筛选条件
export function screenFind(params) {
  return request({ url: '/api/Volunteer/screenFind',method: 'post',data: params})
}
//智能筛选专业
export function college_intell_screen(params){
  return request({ url: '/api/Volunteer/college_intell_screen',method: 'post',data: params})
}
//按高校检索
export function college_gaoxiao_screen(params){
  return request({ url: '/api/Volunteer/college_gaoxiao_screen',method: 'post',data: params})
}
//查看结果
export function college_result_screen(params){
  return request({ url: '/api/Volunteer/college_result_screen',method: 'post',data: params})
}
//一键填报
export function addAll(params){
  return request({ url: '/api/Volunteer/addAll',method: 'post',data: params})
}
//删除所有的志愿列表
export function deleteAll(params){
  return request({ url: '/api/Volunteer/deleteAll',method: 'post',data: params})
}
//获取折线图数据
export function getOnequarter(params) {
  return request({ url: '/api/Volunteer/getOnequarter',method: 'post',data: params})
}
//修改志愿单
export function update(params) {
  return request({ url: '/api/Volunteer/update',method: 'post',data: params})
}
//清除高亮
export function updateIsgao(params) {
  return request({ url: '/api/Volunteer/updateIsgao',method: 'post',data: params})
}
//判断是否可修改
export function isYouxiao(params) {
  return request({ url: '/api/Volunteer/isYouxiao',method: 'post',data: params})
}
//获取志愿单总数
export function Volunteer_currentCount(params) {
  return request({ url: '/api/Volunteer/currentCount',method: 'post',data: params})
}
//导入前清理志愿单
export function clearResult(params) {
	return request({ url: '/api/Volunteer/clearResultData',method: 'post',data: params})
}

//导入
export function importResult(params) {
	return request({ url: '/api/Volunteer/importResultData',method: 'post',data: params})
}
//导出
export function exportResult(params) {
	return request({ url: '/api/Volunteer/exportResultData',method: 'post',data: params})
}




// WEBPACK FOOTER //
// ./src/api/gw/volunteer.js